import { qo } from '../dom';
import { t } from '../i18n';
import { toast } from './toast';

/** Copia para a área de transferência; sem permissão, deixa o texto selecionado num textarea de apoio. */
export async function copy(text: string, fallbackSel = '#io-box'): Promise<void> {
  try {
    await navigator.clipboard.writeText(text);
    toast(t('msg.copied'));
  } catch {
    const ta = qo<HTMLTextAreaElement>(fallbackSel);
    if (ta) { ta.value = text; ta.select(); }
    toast('Ctrl+C');
  }
}
